import { Marker } from 'src/app/components/map/google-map/marker/marker';
import { MarkerConfig, MarkerPoint } from 'src/app/components/map/google-map/marker/marker.config';
import { MSLatLng } from 'src/app/models/map.model';

export type IconOptions = {
  url: string;
  anchor: [number, number];
};

export class MapsNativeMarker {
  constructor(private marker: Marker) {}

  async setVisible(visible: boolean) {
    const config: Partial<MarkerConfig> = {
      visible
    };
    await this.marker.update(config);
  }

  async setPosition(position: MSLatLng) {
    const config: Partial<MarkerConfig> = {
      coordinate: position
    };
    await this.marker.update(config);
  }

  async setIcon(opts: IconOptions) {
    const anchorPoint: MarkerPoint = {
      x: opts.anchor[0],
      y: opts.anchor[1]
    };

    const config: Partial<MarkerConfig> = {
      iconUrl: opts.url,
      iconAnchor: anchorPoint
    };

    await this.marker.update(config);
  }

  async setInfoContent(title: string, snippet: string) {
    const config: Partial<MarkerConfig> = {
      title,
      snippet
    };
    await this.marker.update(config);
  }

  async remove() {
    await this.marker.remove();
  }
}
